import { render, staticRenderFns } from "./MoveRule.vue?vue&type=template&id=8ae619b8&scoped=true&"
import script from "./MoveRule.vue?vue&type=script&lang=js&"
export * from "./MoveRule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae619b8",
  null
  
)

export default component.exports